<template>
	<nav class="hidden lg:flex px-4 h-16 justify-between items-center bg-(--secondary-brown)">
		<ul class="flex items-center justify-around gap-8 w-full font-(family-name:--josefin-sans-font) text-xl font-light text-(--primary-beige) uppercase">
			<li class="h-full">
				<NuxtLink
					:to="ROUTES.home"
					:class="[
						'relative hover:scale-110 flex transition duration-(--default-transition-duration)',
						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased',
						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(--primary-beige) before:opacity-75 after:bg-(--primary-beige) after:opacity-75',
						(activeRoute === ROUTES.home) ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '',
						(activeRoute === ROUTES.base) ? 'before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'before:bg-(--primary-beige) after:bg-(--primary-beige)'
					]"
				>
					Home
				</NuxtLink>
			</li>
			<li class="h-full">
				<NuxtLink
					:to="ROUTES.gallery"
					:class="[
						'relative hover:scale-110 flex transition duration-(--default-transition-duration)',
						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased',
						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(--primary-beige) before:opacity-75 after:bg-(--primary-beige) after:opacity-75',
						activeRoute === ROUTES.gallery ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '',
						(activeRoute === ROUTES.base) ? 'before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'before:bg-(--primary-beige) after:bg-(--primary-beige)'
					]"
				>
					Gallery
				</NuxtLink>
			</li>
			<li class="h-full">
				<NuxtLink
					:to="ROUTES.travel"
					:class="[
						'relative hover:scale-110 flex transition duration-(--default-transition-duration)',
						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased',
						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(--primary-beige) before:opacity-75 after:bg-(--primary-beige) after:opacity-75',
						activeRoute === ROUTES.travel ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '',
						(activeRoute === ROUTES.base) ? 'before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'before:bg-(--primary-beige) after:bg-(--primary-beige)'
					]"
				>
					Travel
				</NuxtLink>
			</li>
			<li class="h-full">
				<NuxtLink
					:to="ROUTES.dressCode"
					:class="[
						'relative hover:scale-110 flex transition duration-(--default-transition-duration)',
						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased',
						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(--primary-beige) before:opacity-75 after:bg-(--primary-beige) after:opacity-75',
						activeRoute === ROUTES.dressCode ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '',
						(activeRoute === ROUTES.base) ? 'before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'before:bg-(--primary-beige) after:bg-(--primary-beige)'
					]"
				>
					Dress Code
				</NuxtLink>
			</li>
			<li class="h-full">
				<NuxtLink
					:to="ROUTES.registry"
					:class="[
						'relative hover:scale-110 flex transition duration-(--default-transition-duration)',
						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased',
						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(--primary-beige) before:opacity-75 after:bg-(--primary-beige) after:opacity-75',
						activeRoute === ROUTES.registry ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '',
						(activeRoute === ROUTES.base) ? 'before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'before:bg-(--primary-beige) after:bg-(--primary-beige)'
					]"
				>
					Registry
				</NuxtLink>
			</li>
			<li class="h-full">
				<NuxtLink
					:to="ROUTES.weddingParty"
					:class="[
						'relative hover:scale-110 flex transition duration-(--default-transition-duration)',
						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased',
						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(--primary-beige) before:opacity-75 after:bg-(--primary-beige) after:opacity-75',
						activeRoute === ROUTES.weddingParty ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '',
						(activeRoute === ROUTES.base) ? 'before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'before:bg-(--primary-beige) after:bg-(--primary-beige)'
					]"
				>
					Wedding Party
				</NuxtLink>
			</li>
			<li class="h-full">
				<NuxtLink
					:to="ROUTES.qAndA"
					:class="[
						'relative hover:scale-110 flex transition duration-(--default-transition-duration)',
						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased',
						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(--primary-beige) before:opacity-75 after:bg-(--primary-beige) after:opacity-75',
						activeRoute === ROUTES.qAndA ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '',
						(activeRoute === ROUTES.base) ? 'before:bg-(--primary-brown) after:bg-(--primary-brown)' : 'before:bg-(--primary-beige) after:bg-(--primary-beige)'
					]"
				>
					Q + A
				</NuxtLink>
			</li>
			<!--			<li class="h-full"> -->
			<!--				<NuxtLink -->
			<!--					:to="ROUTES.rsvp" -->
			<!--					:class="[ -->
			<!--						'relative hover:scale-110 flex transition duration-(&#45;&#45;default-transition-duration)', -->
			<!--						'before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:origin-top-right before:scale-x-0 before:transition-transform before:duration-300 before:ease-in-out hover:before:origin-top-left hover:before:scale-x-100 hover:before:opacity-75 subpixel-antialiased', -->
			<!--						'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:origin-bottom-left after:scale-x-0 after:transition-transform after:duration-300 after:ease-in-out hover:after:origin-bottom-right hover:after:scale-x-100 hover:after:opacity-75 subpixel-antialiased before:bg-(&#45;&#45;primary-beige) before:opacity-75 after:bg-(&#45;&#45;primary-beige) after:opacity-75', -->
			<!--						activeRoute.includes(ROUTES.rsvp) ? 'before:scale-x-100 after:scale-x-100 before:opacity-75 after:opacity-75' : '', -->
			<!--						(activeRoute === ROUTES.base) ? 'before:bg-(&#45;&#45;primary-brown) after:bg-(&#45;&#45;primary-brown)' : 'before:bg-(&#45;&#45;primary-beige) after:bg-(&#45;&#45;primary-beige)' -->
			<!--					]" -->
			<!--				> -->
			<!--					RSVP -->
			<!--				</NuxtLink> -->
			<!--			</li> -->
		</ul>
	</nav>
</template>

<script setup lang="ts">
	const { activeRoute } = utilityStores();
	const { ROUTES } = globalStores();
</script>

<style scoped>

</style>